<div class="morse-letter-space"></div>

<style>
  .morse-letter-space {
    width: 12px;
    height: 12px;
    background: var(--color-0);
    margin-bottom: 3px;
  }
</style>